import * as Yup from 'yup';
import { RequiredString } from '../../schemas/common';

const additionalFieldSchema = Yup.object({
  id: RequiredString().defined(),
  label: RequiredString().defined(),
  required: Yup.boolean().defined(),
  validation_type: Yup.string()
    .oneOf(['numeric', 'alphabetic', 'alphanumeric'])
    .defined(),
  max_length: Yup.number().min(1).max(255).nullable(),
});

export const PaymentLinkValidationSchema = Yup.object({
  name: RequiredString().defined(),
  amount: RequiredString().defined(),
  expiration_date: RequiredString().defined(),
  success_url: Yup.string().url().nullable(),
  return_url: Yup.string().url().nullable(),
  additional_fields: Yup.array().of(additionalFieldSchema).max(5),
});
